import { TrnBusicrUpdateForm, TrnCareerResumeUpdateForm, TrnQualLangUpdateForm, TrnQualUpdateForm, TrnSchlcrUpdateForm, TrnCareerBasicInfoUpdateForm } from '@/types';
import { useForm } from 'vee-validate';
import { bool } from 'yup';

function mapToTrnBusicrUpdateForm(formValues: any) {
  const result: TrnBusicrUpdateForm = {};

  if (formValues.busicrId != null)
    result.busicrId = formValues.busicrId;

  if (formValues.compName)
    result.compName = formValues.compName;

  if (formValues.dept)
    result.dept = formValues.dept;

  if (formValues.indsctgId)
    result.indsctgId = formValues.indsctgId;

  if (formValues.listedId)
    result.listedId = formValues.listedId;

  if (formValues.frigncptlFlg)
    result.frigncptlFlg = formValues.frigncptlFlg;

  if (formValues.employeeNum)
    result.employeeNum = formValues.employeeNum;

  if (formValues.capital)
    result.capital = formValues.capital;

  if (formValues.busiContents)
    result.busiContents = formValues.busiContents;

  if (formValues.annualIncm)
    result.annualIncm = formValues.annualIncm;

  if (formValues.empTypeId)
    result.empTypeId = formValues.empTypeId;

  if (formValues.post)
    result.post = formValues.post;

  if (formValues.wkPeriodsDateY)
    result.wkPeriodsDateY = formValues.wkPeriodsDateY;

  if (formValues.wkPeriodsDateM)
    result.wkPeriodsDateM = formValues.wkPeriodsDateM;

  if (formValues.wkPeriodeDateY)
    result.wkPeriodeDateY = formValues.wkPeriodeDateY;

  if (formValues.wkPeriodeDateM)
    result.wkPeriodeDateM = formValues.wkPeriodeDateM;

  if (formValues.quitRsn)
    result.quitRsn = formValues.quitRsn;

  if (formValues.wkContents)
    result.wkContents = formValues.wkContents;

  if (formValues.fromClassification)
    result.fromClassification = formValues.fromClassification;

  if (formValues.toClassification)
    result.toClassification = formValues.toClassification;
  return result;
}

function mapToTrnSchlcrUpdateForm(formValues: any) {
  const result: TrnSchlcrUpdateForm = {};

  if (formValues.schlName)
    result.schlName = formValues.schlName;

  if (formValues.schlDeptName)
    result.schlDeptName = formValues.schlDeptName;

  if (formValues.entranceYr)
    result.entranceYr = formValues.entranceYr;

  if (formValues.entranceMon)
    result.entranceMon = formValues.entranceMon;

  if (formValues.entranceFlg)
    result.entranceFlg = formValues.entranceFlg;

  if (formValues.gradYr)
    result.gradYr = formValues.gradYr;

  if (formValues.gradMon)
    result.gradMon = formValues.gradMon;

  if (formValues.gradFlg)
    result.gradFlg = formValues.gradFlg;

  if (formValues.schlId)
    result.schlId = formValues.schlId;
  return result;
}

function mapToTrnQualUpdateForm(formValues: any) {
  const result: TrnQualUpdateForm = {};

  if (formValues.qualYr)
    result.qualYr = formValues.qualYr;

  if (formValues.qualMon)
    result.qualMon = formValues.qualMon;

  if (formValues.qualDetails)
    result.qualDetails = formValues.qualDetails;

  if (formValues.licenseId)
    result.licenseId = formValues.licenseId;
  return result;
}

function mapToTrnQualLangUpdateForm(formValues: any) {
  const result: TrnQualLangUpdateForm = {};

  if (formValues.toeic)
    result.toeic = formValues.toeic;

  if (formValues.toeicY)
    result.toeicY = formValues.toeicY;

  if (formValues.toeicM)
    result.toeicM = formValues.toeicM;

  if (formValues.toefl)
    result.toefl = formValues.toefl;

  if (formValues.toeflY)
    result.toeflY = formValues.toeflY;

  if (formValues.toeflM)
    result.toeflM = formValues.toeflM;

  if (formValues.engSpeakSklId)
    result.engSpeakSklId = formValues.engSpeakSklId;

  if (formValues.engReadSklId)
    result.engReadSklId = formValues.engReadSklId;

  if (formValues.engWriteSklId)
    result.engWriteSklId = formValues.engWriteSklId;

  if (formValues.engExpYear)
    result.engExpYear = formValues.engExpYear;

  if (formValues.engMemo)
    result.engMemo = formValues.engMemo;

  if (formValues.otrLang1Id)
    result.otrLang1Id = formValues.otrLang1Id;

  if (formValues.otrSpeak1Id)
    result.otrSpeak1Id = formValues.otrSpeak1Id;

  if (formValues.otrRead1Id)
    result.otrRead1Id = formValues.otrRead1Id;

  if (formValues.otrWrite1Id)
    result.otrWrite1Id = formValues.otrWrite1Id;

  if (formValues.otrLangExpYear1)
    result.otrLangExpYear1 = formValues.otrLangExpYear1;

  if (formValues.otrLang2Id)
    result.otrLang2Id = formValues.otrLang2Id;

  if (formValues.otrSpeak2Id)
    result.otrSpeak2Id = formValues.otrSpeak2Id;

  if (formValues.otrRead2Id)
    result.otrRead2Id = formValues.otrRead2Id;

  if (formValues.otrWrite2Id)
    result.otrWrite2Id = formValues.otrWrite2Id;

  if (formValues.otrLangExpYear2)
    result.otrLangExpYear2 = formValues.otrLangExpYear2;

  if (formValues.otrLangMemo)
    result.otrLangMemo = formValues.otrLangMemo;

  if (formValues.docReadingFlg)
    result.docReadingFlg = formValues.docReadingFlg;

  if (formValues.toExchangeEmailFlg)
    result.toExchangeEmailFlg = formValues.toExchangeEmailFlg;

  if (formValues.telConversationFlg)
    result.telConversationFlg = formValues.telConversationFlg;

  if (formValues.conferenceInEngFlg)
    result.conferenceInEngFlg = formValues.conferenceInEngFlg;

  if (formValues.busiTalkAndNegoInEngFlg)
    result.busiTalkAndNegoInEngFlg = formValues.busiTalkAndNegoInEngFlg;

  if (formValues.stayAbroadFlg)
    result.stayAbroadFlg = formValues.stayAbroadFlg;

  if (formValues.otrLang3Id)
    result.otrLang3Id = formValues.otrLang3Id;

  if (formValues.otrSpeak3Id)
    result.otrSpeak3Id = formValues.otrSpeak3Id;

  if (formValues.otrRead3Id)
    result.otrRead3Id = formValues.otrRead3Id;

  if (formValues.otrWrite3Id)
    result.otrWrite3Id = formValues.otrWrite3Id;

  if (formValues.otrLangExpYear3)
    result.otrLangExpYear3 = formValues.otrLangExpYear3;

  if (formValues.englishLevelId)
    result.englishLevelId = formValues.englishLevelId;

  if (formValues.otrLang1LevelId)
    result.otrLang1LevelId = formValues.otrLang1LevelId;

  if (formValues.otrLang2LevelId)
    result.otrLang2LevelId = formValues.otrLang2LevelId;

  if (formValues.otrLang3LevelId)
    result.otrLang3LevelId = formValues.otrLang3LevelId;
  return result;
}

function mapToTrnCareerResumeUpdateForm(formValues: any) {
  const result: TrnCareerResumeUpdateForm = {};
  let i = 0;
  if (formValues.zipId1)
    result.zipId1 = formValues.zipId1;

  if (formValues.zipId2)
    result.zipId2 = formValues.zipId2;

  if (formValues.prefId)
    result.prefId = formValues.prefId;

  if (formValues.addr1)
    result.addr1 = formValues.addr1;

  if (formValues.addr2)
    result.addr2 = formValues.addr2;

  if (formValues.addr3)
    result.addr3 = formValues.addr3;

  if (formValues.addr1Kana)
    result.addr1Kana = formValues.addr1Kana;

  if (formValues.addr2Kana)
    result.addr2Kana = formValues.addr2Kana;

  if (formValues.nearestStationId)
    result.nearestStationId = formValues.nearestStationId;

  if (formValues.walkBusFlg)
    result.walkBusFlg = formValues.walkBusFlg;

  if (formValues.walkBusTime != null)
    result.walkBusTime = formValues.walkBusTime;

  if (formValues.inhabitTypeId)
    result.inhabitTypeId = formValues.inhabitTypeId;

  if (formValues.currentAnnualIncomeNum != null)
    result.currentAnnualIncomeNum = formValues.currentAnnualIncomeNum;

  if (formValues.monthlyAnnualIncomeNum != null)
    result.monthlyAnnualIncomeNum = formValues.monthlyAnnualIncomeNum;

  if (formValues.yearBonus != null)
    result.yearBonus = formValues.yearBonus;

  if (formValues.allowanceId1)
    result.allowanceId1 = formValues.allowanceId1;

  if (formValues.allowanceId2)
    result.allowanceId2 = formValues.allowanceId2;

  if (formValues.allowanceId3)
    result.allowanceId3 = formValues.allowanceId3;

  if (formValues.allowanceId4)
    result.allowanceId4 = formValues.allowanceId4;

  if (formValues.allowanceNum1 != null)
    result.allowanceNum1 = formValues.allowanceNum1;

  if (formValues.allowanceNum2 != null)
    result.allowanceNum2 = formValues.allowanceNum2;

  if (formValues.allowanceNum3 != null)
    result.allowanceNum3 = formValues.allowanceNum3;

  if (formValues.allowanceNum4 != null)
    result.allowanceNum4 = formValues.allowanceNum4;

  if (formValues.spousePresenceFlg)
    result.spousePresenceFlg = formValues.spousePresenceFlg;

  if (formValues.spouseObligationFlg)
    result.spouseObligationFlg = formValues.spouseObligationFlg;

  if (formValues.dependentsNum != null)
    result.dependentsNum = formValues.dependentsNum;

  if (formValues.hobbySkill)
    result.hobbySkill = formValues.hobbySkill;

  if (formValues.wishOthers)
    result.wishOthers = formValues.wishOthers;

  if (formValues.lastName)
    result.lastName = formValues.lastName;

  if (formValues.firstName)
    result.firstName = formValues.firstName;

  if (formValues.lastNameKana)
    result.lastNameKana = formValues.lastNameKana;

  if (formValues.firstNameKana)
    result.firstNameKana = formValues.firstNameKana;

  if (formValues.birthDateY)
    result.birthDateY = formValues.birthDateY;

  if (formValues.birthDateM)
    result.birthDateM = formValues.birthDateM;

  if (formValues.birthDateD)
    result.birthDateD = formValues.birthDateD;

  if (formValues.sexFlg)
    result.sexFlg = formValues.sexFlg;

  if (formValues.telHome)
    result.telHome = formValues.telHome;

  if (formValues.telCellular)
    result.telCellular = formValues.telCellular;

  if (formValues.otherZipId1)
    result.otherZipId1 = formValues.otherZipId1;

  if (formValues.otherZipId2)
    result.otherZipId2 = formValues.otherZipId2;

  if (formValues.otherZipId1 || formValues.otherZipId2)
    result.otherZipId = formValues.otherZipId1 + formValues.otherZipId2;

  if (formValues.otherPrefId)
    result.otherPrefId = formValues.otherPrefId;

  if (formValues.otherAddr1)
    result.otherAddr1 = formValues.otherAddr1;

  if (formValues.otherAddr2)
    result.otherAddr2 = formValues.otherAddr2;

  if (formValues.otherAddr3)
    result.otherAddr3 = formValues.otherAddr3;

  if (formValues.otherAddr1Kana)
    result.otherAddr1Kana = formValues.otherAddr1Kana;

  if (formValues.otherAddr2Kana)
    result.otherAddr2Kana = formValues.otherAddr2Kana;

  if (formValues.workStatusId)
    result.workStatusId = formValues.workStatusId;

  if (formValues.expIndsCtg1Id)
    result.expIndsCtg1Id = formValues.expIndsCtg1Id;

  if (formValues.expIndSctg1YearsId)
    result.expIndSctg1YearsId = formValues.expIndSctg1YearsId;

  if (formValues.expIndsCtg2Id)
    result.expIndsCtg2Id = formValues.expIndsCtg2Id;

  if (formValues.expIndSctg2YearsId)
    result.expIndSctg2YearsId = formValues.expIndSctg2YearsId;

  if (formValues.expIndsCtg3Id)
    result.expIndsCtg3Id = formValues.expIndsCtg3Id;

  if (formValues.expIndSctg3YearsId)
    result.expIndSctg3YearsId = formValues.expIndSctg3YearsId;

  if (formValues.expIndsCtg4Id)
    result.expIndsCtg4Id = formValues.expIndsCtg4Id;

  if (formValues.expIndSctg4YearsId)
    result.expIndSctg4YearsId = formValues.expIndSctg4YearsId;

  if (formValues.expIndsCtg5Id)
    result.expIndsCtg5Id = formValues.expIndsCtg5Id;

  if (formValues.expIndSctg5YearsId)
    result.expIndSctg5YearsId = formValues.expIndSctg5YearsId;

  if (formValues.expIndsCtg6Id)
    result.expIndsCtg6Id = formValues.expIndsCtg6Id;

  if (formValues.expIndSctg6YearsId)
    result.expIndSctg6YearsId = formValues.expIndSctg6YearsId;

  if (formValues.expOcupcTg1Id)
    result.expOcupcTg1Id = formValues.expOcupcTg1Id;

  if (formValues.expOcupCtg1YearsId)
    result.expOcupCtg1YearsId = formValues.expOcupCtg1YearsId;

  if (formValues.expOcupcTg2Id)
    result.expOcupcTg2Id = formValues.expOcupcTg2Id;

  if (formValues.expOcupCtg2YearsId)
    result.expOcupCtg2YearsId = formValues.expOcupCtg2YearsId;

  if (formValues.expOcupcTg3Id)
    result.expOcupcTg3Id = formValues.expOcupcTg3Id;

  if (formValues.expOcupCtg3YearsId)
    result.expOcupCtg3YearsId = formValues.expOcupCtg3YearsId;

  if (formValues.expOcupcTg4Id)
    result.expOcupcTg4Id = formValues.expOcupcTg4Id;

  if (formValues.expOcupCtg4YearsId)
    result.expOcupCtg4YearsId = formValues.expOcupCtg4YearsId;

  if (formValues.expOcupcTg5Id)
    result.expOcupcTg5Id = formValues.expOcupcTg5Id;

  if (formValues.expOcupCtg5YearsId)
    result.expOcupCtg5YearsId = formValues.expOcupCtg5YearsId;

  if (formValues.expOcupcTg6Id)
    result.expOcupcTg6Id = formValues.expOcupcTg6Id;

  if (formValues.expOcupCtg6YearsId)
    result.expOcupCtg6YearsId = formValues.expOcupCtg6YearsId;

  if (formValues.expCompNum != null)
    result.expCompNum = formValues.expCompNum;

  if (formValues.managementFlg)
    result.managementFlg = formValues.managementFlg;

  if (formValues.jobSummary)
    result.jobSummary = formValues.jobSummary;

  if (formValues.expKnowledgeAbility)
    result.expKnowledgeAbility = formValues.expKnowledgeAbility;

  if (formValues.selfPr)
    result.selfPr = formValues.selfPr;

  if (formValues.lastSchoolId)
    result.lastSchoolId = formValues.lastSchoolId;

  if (formValues.scienceFlg)
    result.scienceFlg = formValues.scienceFlg;

  if (formValues.qualOther)
    result.qualOther = formValues.qualOther;

  if (formValues.managementPeopleId)
    result.managementPeopleId = formValues.managementPeopleId;

  if (formValues.managementYearId)
    result.managementYearId = formValues.managementYearId;

  if (formValues.busicrDetails && formValues.busicrDetails.length > 0) {
    const busicrDetails = [];
    for (i = 0; i < formValues.busicrDetails.length; i++) {
      const busicrDetail = mapToTrnBusicrUpdateForm(formValues.busicrDetails[i]);
      if (Object.keys(busicrDetail).length > 0) {
        if (!busicrDetail.busicrId) {
          busicrDetail.busicrId = 0;
        }
        busicrDetails.push(busicrDetail);
      }
    }
    if (busicrDetails.length > 0) {
      result.busicrDetails = busicrDetails;
    }
  }

  if (formValues.schlcrDetails && formValues.schlcrDetails.length > 0) {
    const schlcrDetails = [];
    for (i = 0; i < formValues.schlcrDetails.length; i++) {
      const schlcrDetail = mapToTrnSchlcrUpdateForm(formValues.schlcrDetails[i]);
      if (Object.keys(schlcrDetail).length > 0) {
        schlcrDetails.push(schlcrDetail);
      }
    }
    if (schlcrDetails.length > 0) {
      result.schlcrDetails = schlcrDetails;
    }
  }

  if (formValues.qualDetails && formValues.qualDetails.length > 0) {
    const qualDetails = [];
    for (i = 0; i < formValues.qualDetails.length; i++) {
      const qualDetail = mapToTrnQualUpdateForm(formValues.qualDetails[i]);
      if (Object.keys(qualDetail).length > 0) {
        qualDetails.push(qualDetail);
      }
    }
    if (qualDetails.length > 0) {
      result.qualDetails = qualDetails;
    }
  }

  if (formValues.qualLangDetail) {
    const qualLangDetail = mapToTrnQualLangUpdateForm(formValues.qualLangDetail);
    if (Object.keys(qualLangDetail).length > 0)
      result.qualLangDetail = qualLangDetail;
  }

  return result;
}
function mapToTrnCareerBasicInfoUpdateForm(formValues: any) {
  const result: TrnCareerBasicInfoUpdateForm = {};
  if (formValues.zipId1)
    result.zipId1 = formValues.zipId1;

  if (formValues.zipId2)
    result.zipId2 = formValues.zipId2;

  if (formValues.prefId)
    result.prefId = formValues.prefId;

  if (formValues.addr1)
    result.addr1 = formValues.addr1;

  if (formValues.addr2)
    result.addr2 = formValues.addr2;

  if (formValues.addr3)
    result.addr3 = formValues.addr3;

  if (formValues.addr1Kana)
    result.addr1Kana = formValues.addr1Kana;

  if (formValues.addr2Kana)
    result.addr2Kana = formValues.addr2Kana;

  if (formValues.nearestStationId)
    result.nearestStationId = formValues.nearestStationId;

  if (formValues.walkBusFlg)
    result.walkBusFlg = formValues.walkBusFlg;

  if (formValues.walkBusTime != null)
    result.walkBusTime = formValues.walkBusTime;

  if (formValues.inhabitTypeId)
    result.inhabitTypeId = formValues.inhabitTypeId;

  if (formValues.currentAnnualIncomeNum != null)
    result.currentAnnualIncomeNum = formValues.currentAnnualIncomeNum;

  if (formValues.monthlyAnnualIncomeNum != null)
    result.monthlyAnnualIncomeNum = formValues.monthlyAnnualIncomeNum;

  if (formValues.yearBonus != null)
    result.yearBonus = formValues.yearBonus;

  if (formValues.allowanceId1)
    result.allowanceId1 = formValues.allowanceId1;

  if (formValues.allowanceId2)
    result.allowanceId2 = formValues.allowanceId2;

  if (formValues.allowanceId3)
    result.allowanceId3 = formValues.allowanceId3;

  if (formValues.allowanceId4)
    result.allowanceId4 = formValues.allowanceId4;

  if (formValues.allowanceNum1 != null)
    result.allowanceNum1 = formValues.allowanceNum1;

  if (formValues.allowanceNum2 != null)
    result.allowanceNum2 = formValues.allowanceNum2;

  if (formValues.allowanceNum3 != null)
    result.allowanceNum3 = formValues.allowanceNum3;

  if (formValues.allowanceNum4 != null)
    result.allowanceNum4 = formValues.allowanceNum4;

  if (formValues.spousePresenceFlg)
    result.spousePresenceFlg = formValues.spousePresenceFlg;

  if (formValues.spouseObligationFlg)
    result.spouseObligationFlg = formValues.spouseObligationFlg;

  if (formValues.dependentsNum != null)
    result.dependentsNum = formValues.dependentsNum;

  if (formValues.hobbySkill)
    result.hobbySkill = formValues.hobbySkill;

  if (formValues.wishOthers)
    result.wishOthers = formValues.wishOthers;

  if (formValues.lastName)
    result.lastName = formValues.lastName;

  if (formValues.firstName)
    result.firstName = formValues.firstName;

  if (formValues.lastNameKana)
    result.lastNameKana = formValues.lastNameKana;

  if (formValues.firstNameKana)
    result.firstNameKana = formValues.firstNameKana;

  if (formValues.birthDateY)
    result.birthDateY = formValues.birthDateY;

  if (formValues.birthDateM)
    result.birthDateM = formValues.birthDateM;

  if (formValues.birthDateD)
    result.birthDateD = formValues.birthDateD;

  if (formValues.sexFlg)
    result.sexFlg = formValues.sexFlg;

  if (formValues.telHome)
    result.telHome = formValues.telHome;

  if (formValues.telCellular)
    result.telCellular = formValues.telCellular;

  if (formValues.otherZipId1)
    result.otherZipId1 = formValues.otherZipId1;

  if (formValues.otherZipId2)
    result.otherZipId2 = formValues.otherZipId2;

  if (formValues.otherZipId1 || formValues.otherZipId2)
    result.otherZipId = formValues.otherZipId1 + formValues.otherZipId2;

  if (formValues.otherPrefId)
    result.otherPrefId = formValues.otherPrefId;

  if (formValues.otherAddr1)
    result.otherAddr1 = formValues.otherAddr1;

  if (formValues.otherAddr2)
    result.otherAddr2 = formValues.otherAddr2;

  if (formValues.otherAddr3)
    result.otherAddr3 = formValues.otherAddr3;

  if (formValues.otherAddr1Kana)
    result.otherAddr1Kana = formValues.otherAddr1Kana;

  if (formValues.otherAddr2Kana)
    result.otherAddr2Kana = formValues.otherAddr2Kana;

  return result;
}

function updateTabStatus(formData: Record<string, any>, tabStatus: any) {
  // 基本情報
  const basicInfoRequiredFields = [
    'zipId1',
    'zipId2',
    'prefId',
    'addr1',
    'addr2',
    'currentAnnualIncomeNum',
    'lastName',
    'firstName',
    'lastNameKana',
    'firstNameKana',
    'birthDateY',
    'birthDateM',
    'birthDateD',
    'telHome',
  ];
  tabStatus.basicInfo.completed = true;
  for (let i = 0; i < basicInfoRequiredFields.length; i++) {
    const field = basicInfoRequiredFields[i];
    if (!formData[field]) {
      tabStatus.basicInfo.completed = false;
      break;
    }
  }

  // 職務要約
  const worksummaryRequiredFields = [
    'workStatusId',
    'expIndsCtg1Id',
    'expOcupcTg1Id',
  ];
  tabStatus.worksummary.completed = true;
  for (let i = 0; i < worksummaryRequiredFields.length; i++) {
    const field = worksummaryRequiredFields[i];
    if (!formData[field]) {
      tabStatus.worksummary.completed = false;
      break;
    }
  }
  if (formData.managementFlg == 1 && !(formData.managementPeopleId && formData.managementYearId)) {
    tabStatus.worksummary.completed = false;
  }
  
  // 職務経歴
  const busicrDetailsRequiredFields = [
    'compName',
    'wkPeriodsDateM',
    'wkPeriodsDateY',
    'fromClassification',
    'indsctgId',
  ];
  tabStatus.workexperience.completed = true;
  const busicrDetails = formData.busicrDetails as Array<Record<string, any>>;
  if (busicrDetails) {
    for (let i = 0; i < busicrDetails.length; i++) {
      const item = busicrDetails[i] as Record<string, any>;
      if (!Object.prototype.hasOwnProperty.call(item, 'compName'))  continue;

      for (let j = 0; j < busicrDetailsRequiredFields.length; j++) {
        const field = busicrDetailsRequiredFields[j];
        if (!item[field]) {
          tabStatus.workexperience.completed = false;
          break;
        }
      }
    }
  }

  // 学歴
  const educationRequiredFields = [
    'lastSchoolId'
  ];
  tabStatus.education.completed = true;
  for (let i = 0; i < educationRequiredFields.length; i++) {
    const field = educationRequiredFields[i];
    if (!formData[field]) {
      tabStatus.education.completed = false;
      break;
    }
  }
  
  // 資格•語学
  const qualLangDetailFields = [
    'toeic',
    'toeicY',
    'toeicM',
    'toefl',
    'toeflY',
    'toeflM',
    'englishLevelId',
    'engMemo',
    'otrLang1Id',
    'otrLang1LevelId',
    'otrLang2Id',
    'otrLang2LevelId',
    'otrLang3Id',
    'otrLang3LevelId',
  ];
  const qualDetailFields = [
    'licenseId',
    'qualYr',
    'qualMon',
  ];
  tabStatus.qualifications.completed = true;
  const qualLangDetail = formData.qualLangDetail as Record<string, any>;
  const qualDetails = formData.qualDetails as Record<string, any>[];

  const isQualOtherEmpty = !formData.qualOther;
  let isQualLangDetailEmpty = true;
  let isQualDetailsEmpty = true;
  if (qualLangDetail) {
    for (let i = 0; i < qualLangDetailFields.length; i++) {
      const key = qualLangDetailFields[i];
      if (qualLangDetail[key]) {
        isQualLangDetailEmpty = false;
        break;
      }
    }
  }
  if (qualDetails) {
    for (let i = 0; i < qualDetails.length; i++) {
      const item = qualDetails[i] as Record<string, any>;
      for (let j = 0; j < qualDetailFields.length; j++) {
        const field = qualDetailFields[j];
        if (item[field]) {
          isQualDetailsEmpty = false;
          break;
        }
      }
    }
  }
  tabStatus.qualifications.completed = !(isQualOtherEmpty && isQualLangDetailEmpty && isQualDetailsEmpty);
}

const validationFields = {
  basicInfo: {
    single: [
      'zipId1',
      'zipId2',
      'prefId',
      'addr1',
      'addr2',
      'addr3',
      'addr1Kana',
      'addr2Kana',
      'walkBusTime',
      'currentAnnualIncomeNum',
      'monthlyAnnualIncomeNum',
      'yearBonus',
      'allowanceNum1',
      'allowanceNum2',
      'allowanceNum3',
      'allowanceNum4',
      'dependentsNum',
      'hobbySkill',
      'wishOthers',
      'lastName',
      'firstName',
      'lastNameKana',
      'firstNameKana',
      'birthDateY',
      'birthDateM',
      'birthDateD',
      'telHome',
      'telCellular',
      'otherZipId1',
      'otherZipId2',
      'otherAddr1',
      'otherAddr2',
      'otherAddr3',
      'otherAddr1Kana',
      'otherAddr2Kana',
    ],
    multi: null,
  },
  worksummary: {
    single: [
      'workStatusId',
      'expIndsCtg1Id',
      'expOcupcTg1Id',
      'expCompNum',
      'managementPeopleId',
      'managementYearId',
      'jobSummary',
      'expKnowledgeAbility',
      'selfPr',
    ],
    multi: null,
  },
  workexperience: {
    single: null,
    multi: [
      'busicrDetails[${i}].compName',
      'busicrDetails[${i}].wkPeriodsDateY',
      'busicrDetails[${i}].wkPeriodsDateM',
      'busicrDetails[${i}].fromClassification',
      'busicrDetails[${i}].wkPeriodeDateY',
      'busicrDetails[${i}].wkPeriodeDateM',
      'busicrDetails[${i}].toClassification',
      'busicrDetails[${i}].dept',
      'busicrDetails[${i}].wkContents',
      'busicrDetails[${i}].post',
      'busicrDetails[${i}].annualIncm',
      'busicrDetails[${i}].quitRsn',
      'busicrDetails[${i}].indsctgId',
      'busicrDetails[${i}].busiContents',
      'busicrDetails[${i}].capital',
      'busicrDetails[${i}].employeeNum',
    ]
  },
  education: {
    single: [
      'lastSchoolId',
    ],
    multi: [
      'schlcrDetails[${i}].schlId',
      'schlcrDetails[${i}].schlName',
      'schlcrDetails[${i}].schlDeptName',
      'schlcrDetails[${i}].entranceMon',
      'schlcrDetails[${i}].entranceYr',
      'schlcrDetails[${i}].entranceFlg',
      'schlcrDetails[${i}].gradMon',
      'schlcrDetails[${i}].gradYr',
      'schlcrDetails[${i}].gradFlg',
    ]
  },
  qualifications: {
    single: [
      'qualOther',
      'qualLangDetail.toeic',
      'qualLangDetail.toeicY',
      'qualLangDetail.toeicM',
      'qualLangDetail.toefl',
      'qualLangDetail.toeflY',
      'qualLangDetail.toeflM',
      'qualLangDetail.engMemo',
    ],
    multi: [
      'qualDetails[${i}].qualYr',
      'qualDetails[${i}].qualMon',
    ]
  },
};

async function validateResumeTab(tab: string, vForm: ReturnType<typeof useForm>): Promise<boolean> {
  if (!(tab in validationFields)) {
    return false;
  }

  const formData = vForm.values as Record<string, any>;
  const fieldsToValidate = validationFields[tab as keyof typeof validationFields];
  const validationPromises: Promise<{ valid: boolean }>[] = [];

  // Collect validation promises for single items
  if (fieldsToValidate.single) {
    const managementFields = ['managementPeopleId', 'managementYearId'];
    for (const field of fieldsToValidate.single) {
      if (!(tab === 'worksummary' && managementFields.includes(field) && formData.managementFlg != 1)) {
        validationPromises.push(vForm.validateField(field));
      }
    }
  }

  // Collect validation promises for dynamic items
  if (fieldsToValidate.multi) {
    const arrayLength = getArrayLength(tab, formData);
    for (let i = 0; i < arrayLength; i++) {
      for (const fieldTemplate of fieldsToValidate.multi) {
        const field = fieldTemplate.replace('${i}', i.toString());
        validationPromises.push(vForm.validateField(field));
      }
    }
  }

  // Wait for all validations to complete simultaneously
  const results = await Promise.all(validationPromises);
  
  // Check if any validation failed
  return results.every(result => result.valid);
}

// Helper function to determine the length of the array based on tab
function getArrayLength(tab: string, formData: Record<string, any>): number {
  switch (tab) {
    case 'workexperience':
      return formData.busicrDetails?.length || 0;
    case 'education':
      return formData.schlcrDetails?.length || 0;
    case 'qualifications':
      return formData.qualDetails?.length || 0;
    default:
      return 0;
  }
}

export const resumeFormUtils = {
  mapToTrnCareerResumeUpdateForm,
  mapToTrnCareerBasicInfoUpdateForm,
  updateTabStatus,
  validateResumeTab,
};